/**
 * Le recadrage propose deux formes de logo : "Carré" (1:1) et "Rectangle" (3:1).
 * En dessous de ce ratio largeur/hauteur, on considère le logo comme carré-ish
 * (seuil au milieu, biaisé vers le carré) et il est affiché plus grand dans la nav.
 */
export const SQUARE_LOGO_MAX_RATIO = 1.5;

/** `true` si le logo (ratio largeur / hauteur) doit être traité comme carré. */
export function isSquareLogoRatio(ratio: number | null | undefined): boolean {
  return (
    typeof ratio === 'number' &&
    Number.isFinite(ratio) &&
    ratio > 0 &&
    ratio < SQUARE_LOGO_MAX_RATIO
  );
}
